import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import content from '../content';
import useWindowPosition from '../hook/useWindowPosition';
import { Link } from 'react-router-dom';

export default function Work() {
	const animated = useWindowPosition('header', 0.6);
	return (
		<div
			className="min-h-screen flex justify-center items-center flex-col"
			style={{
				background: '#FEFEFE',
			}}
			id="mywork"
		>
			<h1 className="text-5xl font-dosis font-bold">{content.work.title}</h1>
			<p className="text-gray-600 text-2xl font-dosis mb-10">I have done</p>

			{content.work.works.map((works, index) => {
				return (
					<div className="flex flex-col md:flex-row justify-between items-center w-11/12 ">
						<div
							style={{
								width: '300px',
								height: '300px',
								borderRadius: '50%',
								backgroundColor: 'deepskyblue',
								position: 'absolute',
							}}
						/>
						<LazyLoadImage
							key={index}
							effect="blur"
							placeholderSrc={works.imgPlaceholder}
							src={works.img}
							// style={{backgroundColor: "red"}}
							// background = "url('https://www.vhv.rs/dpng/d/443-4431349_yellow-circle-png-transparent-png-download.png')"
							// style={{backgroundImage: "url('https://www.vhv.rs/dpng/d/443-4431349_yellow-circle-png-transparent-png-download.png')"}}
							alt="phone prototype"
							className="m-10 transtion duration-2000 ease-in-out z-10  md:w-3/5 w-4/5"
						/>
						{/* </div> */}
						<div
							className="transtion duration-2000 ease-in-out p-10 max-w-xl lg:max-w-3xl rounded-lg hidden md:block"
							style={{
								border: '1px solid #e5ecf9',
								transform: animated
									? 'translate(-10%, 0%) rotate3d(0.540, -0.95, 0, 360deg) rotateZ(0deg)'
									: '',
								boxShadow:
									'35px 50px 90px -25px rgba(50, 50, 95, 0.5), 20px 35px 75px -35px rgba(0, 0, 0, 0.5)',
							}}
						>
							<div key={index}>
								{/* <img class="w-16 h-16 rounded-full mx-auto" src={works.ima}style={{position:"absolute", top: "0px", left:"0px", backgroundColor: "transparent !important"}} alt="" width="384" height="512"/> */}
								<h1
									className={` ${
										animated ? '' : 'translate-y-10 opacity-0'
									}   transform transition duration-2000 inline-block m-4  font-dosis text-xl font-bold`}
								>
									{works.projectName}
								</h1>
								<p
									className={`${
										animated ? '' : 'translate-y-10 opacity-0'
									}  transform transition duration-2000 inline-block w-11/12 m-4  text-xl font-dosis`}
								>
									{works.desc}
								</p>

								<h1
									className={` ${
										animated ? '' : 'translate-y-10 opacity-0'
									}   transform transition duration-2000 inline-block m-4  font-dosis text-xl font-bold`}
								>
									Technologies - {works.technologies}
								</h1>

								<button
									className={`${
										animated ? '' : 'translate-y-10 opacity-0'
									} transform transition duration-2000  px-20 py-3 m-4 bg-black flex justify-around text-white rounded-lg shadow-2xl`}
									onClick={()=> window.open(works.site)}
									
								>
									<img
										src="https://timo.engineer/assets/icons/rocket.svg"
										alt="rocket"
										className="mr-5"
									/>
									<p className="text-lg">Website</p>
								</button>
							</div>
						</div>
						<div
							// className="flex justify-center items-center md:hidden "
							className={`flex justify-center items-center md:hidden ${
								index % 2 !== 0 ? 'animate-bounce' : 'animate-bounceFirst'
							}`}
							// className="transtion duration-2000 ease-in-out p-10 max-w-xl lg:max-w-3xl rounded-lg hidden md:block"
							style={{
								border: '1px solid #e5ecf9',
								// transform: animated
								//   ? 'translate(-10%, 0%) rotate3d(0.540, -0.95, 0, 360deg) rotateZ(0deg)'
								//   : '',
								boxShadow:
									'35px 50px 90px -25px rgba(50, 50, 95, 0.5), 20px 35px 75px -35px rgba(0, 0, 0, 0.5)',
							}}
						>
							<div key={index}>
								<h1
									className={` ${
										animated ? '' : 'translate-y-10 opacity-0'
									}   transform transition duration-2000 inline-block m-4  font-dosis text-xl font-bold`}
								>
									{works.projectName}
								</h1>
								<p
									className={`${
										animated ? '' : 'translate-y-10 opacity-0'
									}  transform transition duration-2000 inline-block w-11/12 m-4  text-xl font-dosis`}
								>
									{works.desc}
								</p>
								<h1
									className={` ${
										animated ? '' : 'translate-y-10 opacity-0'
									}   transform transition duration-2000 inline-block m-6  font-dosis text-xl font-bold`}
								>
									Technologies - {works.technologies}
								</h1>

								<button
									style={{ marginInline: 'auto' }}
									className={`${
										animated ? '' : 'translate-y-10 opacity-0'
									} transform transition duration-2000  px-20 py-3 m-4 bg-black flex justify-around text-white rounded-lg shadow-2xl`}
									// target = "_blank"
									onClick={()=> window.open(works.site)}
								>
									<img
										src="https://timo.engineer/assets/icons/rocket.svg"
										alt="rocket"
										className="mr-5"
									/>
									<p className="text-lg">Website</p>
								</button>

								{/* </Link> */}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}
